<template>
  <ais-refinement-list
    :attribute="filterAttribute"
    :show-more="showMore"
    :operator="operator"
    :searchable="searchable"
  >
    <template v-slot="{ items, refine, searchForItems }">
      <div
        v-show="(items?.length ?? 0) === 0"
        class="text-xs bg-gray-75 text-indigo-base rounded-md mt-1"
      >
        <p>No options available. Clear a filter on another category.</p>
      </div>
      <input
        v-if="searchable"
        v-model="facetFilter"
        @input="filterFacets(searchForItems)"
        type="text"
        placeholder="Search and select..."
        class="w-full p-2 mb-2 border rounded"
      />
      <div v-show="items?.length !== 0" class="mt-2">
        <div v-for="item in items" :key="item.value">
          <label class="flex mt-4 items-center mt-0 mb-4">
            <input
              type="checkbox"
              :data-testid="`checkbox-${useKebabCase(item.value)}`"
              :value="item.value"
              :checked="item.isRefined"
              class="w-[16px] h-[16px] border-university-primary m-[8px] form-checkbox"
              @change="
                handleChecked($event.currentTarget.checked, item, refine)
              "
            />
            <div class="flex flex-1 gap-x-[16px]">
              <span
                class="font-montserrat text-university-primary text-sm"
                :data-testid="`checkbox-label-${useKebabCase(item.value)}`"
              >
                {{ item.label }}</span>
                <span v-if="item.count > 0" class="inline-block rounded-[6px] px-[8px] h-[22px] bg-gray-25 text-university-primary">{{ numberFormatter(item.count) }}</span>
            </div>
          </label>
        </div>
      </div>
    </template>
  </ais-refinement-list>
</template>
<script setup>
import { ref } from "vue";
import { AisRefinementList } from "vue-instantsearch/vue3/es";

import { useKebabCase } from "@/composables/stringManupulation";
import { numberFormatter } from "@/util/formatter";

const props = defineProps({
  filterAttribute: {
    type: String,
  },
  searchable: {
    type: Boolean,
    default: false,
  },
  operator: {
    type: String,
    default: "or",
  },
  showMore: {
    type: Boolean,
    default: false,
  },
});

const facetFilter = ref("");

const handleChecked = (isChecked, selectedItem, refine) => {
  refine(selectedItem.value);
};

const filterFacets = (filterFunc) => {
  filterFunc(facetFilter.value);
};
</script>
